import { render } from "./MaintenancePackSpecifiedCommercialTransactionsAlert.vue?vue&type=template&id=20be7822"
import script from "./MaintenancePackSpecifiedCommercialTransactionsAlert.vue?vue&type=script&lang=js"
export * from "./MaintenancePackSpecifiedCommercialTransactionsAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__